import {Component, Inject, Input} from '@angular/core';
import {PROFILE, Profile} from '@infrastructure/http/profile/profile';
import {BaseComponent, WINDOW} from '@vdw/angular-component-library';
import {Observable} from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-texedit-card-external-application',
  templateUrl: './texedit-card-page-external-application.component.html'
})
export class TexeditCardPageExternalApplicationComponent extends BaseComponent {
  @Input() public iconForCard: string;
  @Input() public titleForCard: string;
  @Input() public applicationName: string;
  @Input() public applicationDownloadUrl: string;
  public isOpeningExternalApplication = false;

  public constructor(
    @Inject(PROFILE) private readonly profile: Profile,
    @Inject(WINDOW) private window: Window
  ) {
    super();
  }

  public openExternalApplication(): void {
    this.isOpeningExternalApplication = true;
    this.getExternalApplicationLink()
      .pipe(takeUntil(this.unSubscribeOnViewDestroy))
      .subscribe((externalApplicationLink: string) => {
        this.isOpeningExternalApplication = false;

        try {
          this.window.location = externalApplicationLink;
        } catch {
          this.window.location = externalApplicationLink.replaceAll('//', '///'); //fallback for MsEdge, where it expects an authority seperator to validate the URI
        }
      });
  }

  public downloadExternalApplication(): void {
    this.window.open(this.applicationDownloadUrl);
  }

  private getExternalApplicationLink(): Observable<string> {
    return this.profile.getExternalApplicationKey().pipe(map((externalApplicationKey: string) => `${this.applicationName}://application_key:${externalApplicationKey}`));
  }
}
